import { supabase } from "@/integrations/supabase/client";
import { compressImageForUpload, withExtension } from "@/lib/image-compress";

/**
 * Cache-Control max-age (1 year) for public website images (#742). Only for keys that are
 * unique per upload (timestamp or UUID), so a replaced image always gets a new URL. Never use
 * it on a fixed path that gets overwritten (e.g. branding logos): browsers would keep the old
 * image for a year.
 */
export const LONG_CACHE_CONTROL = "31536000";

/**
 * Upload to the public `website-assets` bucket. Images are resized and re-encoded first
 * (#735); when that changes the type, `path`'s extension changes with it. Cached for a year
 * (`LONG_CACHE_CONTROL`), so `path` must be unique per upload.
 */
export async function uploadWebsiteAsset(picked: File, path: string) {
  const file = await compressImageForUpload(picked);
  const key = file === picked ? path : withExtension(path, file.type);
  const { data, error } = await supabase.storage
    .from("website-assets")
    .upload(key, file, { upsert: true, cacheControl: LONG_CACHE_CONTROL, contentType: file.type || undefined });
  if (error) throw error;
  const { data: urlData } = supabase.storage.from("website-assets").getPublicUrl(data.path);
  return urlData.publicUrl;
}
